import type { IncomingPayment } from '@tectonics/prs/incoming-payment';
import type { UserInputValues } from '@tectonics/prs/user-input-values';
import type { PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';
import type { Maybe } from '@tectonics/utils/types';

export type AnalyticsEventType =
  | 'pageView'
  | 'purchase'
  | 'error'
  | 'voucherGenerate'
  | 'purchaseAttempt'
;

export interface AnalyticsManager {
  readonly setUserInputValues: (userInputValues: UserInputValues) => void;
  readonly setSubmitError: (submitError: Maybe<PlaceOrderErrorPayload>) => void;
  readonly event: (eventType: AnalyticsEventType) => void;
  readonly eventOnce: (eventType: AnalyticsEventType, incomingPayment: IncomingPayment) => void;
}

export abstract class AnalyticsProvider {
  incomingPayment!: IncomingPayment;
  userInputValues!: UserInputValues;
  submitError?: Maybe<PlaceOrderErrorPayload>;

  setUserInputValues(userInputValues: UserInputValues): void {
    this.userInputValues = userInputValues;
  }

  setSubmitError(submitError: Maybe<PlaceOrderErrorPayload>): void {
    this.submitError = submitError;
  }

  init(incomingPayment: IncomingPayment): boolean {
    this.incomingPayment = incomingPayment;
    return false;
  }

  abstract event(eventType: AnalyticsEventType): void;
  abstract eventOnce(eventType: AnalyticsEventType, incomingPayment: IncomingPayment): void;
}
